import { AnalyticsEntityGroup } from '@/entities/analytics';
import { d, t } from '@/ui/i18n/i18n';

const ONE_DAY = 1000 * 60 * 60 * 24;

export const separator = '-';

export const decodeGroup = (group: AnalyticsEntityGroup): string => {
  if (group.start !== null && group.end !== null) {
    const length = group.end.getDate() - group.start.getDate();
    if (length <= ONE_DAY) {
      return d(group.start, 'shortDate');
    }

    return `${d(group.start, 'shortDate')} — ${d(group.end, 'shortDate')}`;
  }

  if (group.title) {
    return group.title;
  }

  if (group.id) {
    return t('analytics.no-title');
  }

  return separator;
};

// the entity folder isn't connected with the backend and entity folder ids are generated from entity item ids
export const mergeEntityItems = (entityFolders : string[], entityItems :number[]) => {
  const mergedEntityItems = [...entityItems];
  if (entityFolders && entityFolders.length > 0) {
    entityFolders.forEach((item:string) => {
      item.split(separator).forEach(id => {
        if (!mergedEntityItems.includes(Number(id))) {
          mergedEntityItems.push(Number(id));
        }
      });
    });
  }
  return mergedEntityItems;
};
